<script lang="ts" setup>
import LeHeading from "@dsk/components/Heading/LeHeading.vue";
import LeProgressDots from "@dsk/components/LeProgressDots.vue";

defineProps<{
  progressActive?: number;
}>();
</script>

<template>
  <div class="le-section-heading">
    <LeHeading tag="h1" size="l">
      <!-- &nbsp; to give a height to the heading, if no text is given -->
      <slot>&nbsp;</slot>
    </LeHeading>

    <LeProgressDots class="le-section-heading__progress-dots" :dots="3" :active="progressActive" />
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-section-heading {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  width: 100%;

  &__progress-dots {
    #media-breakpoint-up(lg, {
      display: none;
    });
  }
}
</style>
